import { CalendarEventChipRenderProps } from '../types';
import { CalendarChip } from './CalendarChip';

export const DefaultChip = ({ eventInfo }: CalendarEventChipRenderProps) => {
  const { timeText } = eventInfo.event.extendedProps;

  return (
    <CalendarChip
      eventInfo={eventInfo}
      className="bg-zinc-500 dark:bg-zinc-800 border-0 border-zinc-500 dark:border-zinc-800 text-white text-[10px]"
    >
      <span className="font-bold">{timeText}</span>
      <span>{eventInfo.event.title}</span>
    </CalendarChip>
  );
};
